module.exports = __webpack_public_path__ + "static/media/taku.5926b729.png";